import { useState } from "react";
import CustomDrawer from "../../../components/GeneralComponents/CustomDrawer";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Tooltip } from "@mui/material";
import InputEditor from "../../../components/Chatting/InputEditor/InputEditor";
import { useTranslation } from "react-i18next";

export default function BroadcastMessage() {
  const { t } = useTranslation();
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [messageText, setMessageText] = useState("");
  const [files, setFiles] = useState([]);
  const [editorInit, setEditorInit] = useState(false);

  const handleOpenDrawer = () => {
    setIsOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setIsOpenDrawer(false);
  };

  const inputData = {
    messageText,
    setMessageText,
    files,
    setFiles,
    isBroadcast: true,
    editorInit,
    setEditorInit,
  };

  return (
    <>
      <div className="theme__svg__box" onClick={handleOpenDrawer}>
        <Tooltip title={t("chatting.broadcast.tooltip")}>
          <Icon icon="bi:broadcast-pin" />
        </Tooltip>
      </div>
      <CustomDrawer
        isOpenDrawer={isOpenDrawer}
        onOpenDrawer={handleOpenDrawer}
        onCloseDrawer={handleCloseDrawer}
        pageTitle={t("chatting.broadcast.title")}
        componentToPassDown={<div>{<InputEditor {...inputData} />}</div>}
      />
    </>
  );
}
